import { render, staticRenderFns } from "./CaseCreate.vue?vue&type=template&id=bec3cab8&scoped=true&"
import script from "./CaseCreate.vue?vue&type=script&lang=ts&"
export * from "./CaseCreate.vue?vue&type=script&lang=ts&"
import style0 from "./CaseCreate.vue?vue&type=style&index=0&id=bec3cab8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec3cab8",
  null
  
)

export default component.exports